import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import NhapKhoService from "services/sale/NhapKhoService";
import { initNhapKhoCt } from "views/app-views/sale/managements/QuanLyKho/NhapKho";

export const getNhapKhoCTByManx = createAsyncThunk(
  "nhapkho/getNhapKhoCTByManx",
  async (data, { rejectWithValue }) => {
    try {
      const response = await NhapKhoService.getNhapKhoCTByManx(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const addNewNhapKhoCT = createAsyncThunk(
  "nhapkho/addNewNhapKhoCT",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.addNhapKhoCT(data);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const updateNhapKhoCT = createAsyncThunk(
  "nhapkho/updateNhapKhoCT",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.updateNhapKhoCT(data);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);
export const deleteNhapKhoCT = createAsyncThunk(
  "nhapkho/deleteNhapKhoCT",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await NhapKhoService.deleteNhapKhoCT(id);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getHangHoaNhapKho = createAsyncThunk(
  "nhapkho/getHangHoaNhapKho",
  async (data, { rejectWithValue }) => {
    try {
      const response = await NhapKhoService.getHangHoaNhapKho(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getHangHoaThayThe = createAsyncThunk(
  "nhapkho/getHangHoaThayThe",
  async (data, { rejectWithValue }) => {
    try {
      const response = await NhapKhoService.getHangHoaThayThe(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getListDonViXuatHDDT = createAsyncThunk(
  "nhapkho/getListDonViXuatHDDT",
  async (data, { rejectWithValue }) => {
    try {
      const response = await NhapKhoService.getListDonViXuatHDDT();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const SendMisa = createAsyncThunk(
  "nhapkho/SendMisa",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.SendMisa(data);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetMauHDDT = createAsyncThunk(
  "nhapkho/GetMauHDDT",
  async (data, { rejectWithValue }) => {
    try {
      const response = await NhapKhoService.GetMauHDDT(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const PhatHanhHDDTMisa = createAsyncThunk(
  "nhapkho/PhatHanhHDDTMisa",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.PhatHanhHDDTMisa(data);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const PhatHanhHDDTMisaGop = createAsyncThunk(
  "nhapkho/PhatHanhHDDTMisaGop",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.PhatHanhHDDTMisaGop(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const ThayTheDieuChinhHDDTMisa = createAsyncThunk(
  "nhapkho/ThayTheDieuChinhHDDTMisa",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.ThayTheDieuChinhHDDTMisa(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const MoDieuChinhHDDTMisa = createAsyncThunk(
  "nhapkho/MoDieuChinhHDDTMisa",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.MoDieuChinhHDDTMisa(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const DsPhieuDieuChinhHDDTMisa = createAsyncThunk(
  "nhapkho/DsPhieuDieuChinhHDDTMisa",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.DsPhieuDieuChinhHDDTMisa(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const CapNhatPhieuDieuChinhHDDTMisa = createAsyncThunk(
  "nhapkho/CapNhatPhieuDieuChinhHDDTMisa",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.CapNhatPhieuDieuChinhHDDTMisa(
        payload
      );
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const XemTruocDieuChinhHDDTMisa = createAsyncThunk(
  "nhapkho/XemTruocDieuChinhHDDTMisa",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.XemTruocDieuChinhHDDTMisa(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const HuyDieuChinhHDDTMisa = createAsyncThunk(
  "nhapkho/HuyDieuChinhHDDTMisa",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.HuyDieuChinhHDDTMisa(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const InHDDTMisa = createAsyncThunk(
  "nhapkho/InHDDTMisa",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await NhapKhoService.InHDDTMisa(data);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  nhapKhoCTList: [],
  hangHoaNhapKhoList: [],
  hangHoaThayTheList: [],
  MauHDDT: [],
  ListDonViXuatHDDT: [],
};

export const nhapkhoSlice = createSlice({
  name: "nhapkho",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setHisInfo: (state, action) => {
      state.hisInfoList = action.payload;
    },
    setNhapKhoCTList: (state, action) => {
      state.nhapKhoCTList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //
      .addCase(getListDonViXuatHDDT.pending, (state) => {
        state.loading = true;
      })
      .addCase(getListDonViXuatHDDT.fulfilled, (state, action) => {
        state.loading = false;
        state.ListDonViXuatHDDT = action.payload;
      })
      .addCase(getListDonViXuatHDDT.rejected, (state, action) => {
        state.loading = false;
      })
      //
      //
      .addCase(GetMauHDDT.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetMauHDDT.fulfilled, (state, action) => {
        state.loading = false;
        state.MauHDDT = action.payload;
      })
      .addCase(GetMauHDDT.rejected, (state, action) => {
        state.loading = false;
      })
      //
      .addCase(getNhapKhoCTByManx.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNhapKhoCTByManx.fulfilled, (state, action) => {
        state.loading = false;
        state.nhapKhoCTList = [initNhapKhoCt, ...action.payload];
      })
      .addCase(getNhapKhoCTByManx.rejected, (state, action) => {
        state.loading = false;
      })
      //
      .addCase(addNewNhapKhoCT.pending, (state) => {
        state.loading = true;
      })
      .addCase(addNewNhapKhoCT.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addNewNhapKhoCT.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateNhapKhoCT.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateNhapKhoCT.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateNhapKhoCT.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteNhapKhoCT.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteNhapKhoCT.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteNhapKhoCT.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getHangHoaNhapKho.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHangHoaNhapKho.fulfilled, (state, action) => {
        state.loading = false;
        state.hangHoaNhapKhoList = action.payload;
      })
      .addCase(getHangHoaNhapKho.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getHangHoaThayThe.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHangHoaThayThe.fulfilled, (state, action) => {
        state.loading = false;
        state.hangHoaThayTheList = action.payload;
      })
      .addCase(getHangHoaThayThe.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setHisInfo, setNhapKhoCTList } =
  nhapkhoSlice.actions;

export default nhapkhoSlice.reducer;
